<template>
	<div class="wrap">
		<div class="feed-wrap">
			<div class="feed-top">
				<span>发布者：{{feedDetailModel.nickName}}</span>
				<span>发布时间：{{feedDetailModel.addTime|datefmt2('YYYY-MM-DD HH:mm:ss')}}</span>
			</div>
			<div>{{feedDetailModel.title}}</div>
			<div v-if="feedDetailModel.feedType==1">
				<img :src="feedDetailModel.fileUrl"/>
			</div>
			<div v-if="feedDetailModel.feedType==2">
				<video autoplay muted :src="feedDetailModel.fileUrl"></video>
			</div>
		</div>
		<div class="activity-form-wrap">
			<el-form :inline="true" class="activity-form">
				<el-form-item label="显示状态">
					<el-select v-model="showFlag" @change="setSelectedShow">
						<el-option label="全部" value=""></el-option>
						<el-option label="不显示" value="0"></el-option>
						<el-option label="显示" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="评论内容">
					<el-input v-model="title" placeholder="请输入评论内容" clearable></el-input>
				</el-form-item>
				<el-form-item label="评论人名称">
					<el-input v-model="discussUserName" placeholder="请输入评论人名称" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">搜索</el-button>
					<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
				</el-form-item>
			</el-form>	
		</div>
		<el-table border size="mini" :data="dataList" style="width: 100%">
			<el-table-column prop="userName" label="账号">
			</el-table-column>
			<el-table-column prop="discussUserName" label="评论人">
			</el-table-column>
			<el-table-column prop="title" label="评论内容">
			</el-table-column>
			<el-table-column prop="addTime" label="评论时间">
				<template slot-scope="scope">
					<span>{{scope.row.addTime |datefmt2('YYYY-MM-DD HH:mm:ss')}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="操作">
				<template slot-scope="scope">
					<span class="text-link" @click="toDetail(scope.row)">详情</span>
				</template>
			</el-table-column>
		</el-table>
		<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
		<!--评价详情弹窗-->
		<el-dialog title="评论表详情" :visible.sync="visibleDialog" width="50%" @close="visibleDialog=false">
			<table class="table-column2">
				<tr>
					<th>评论人名称</th>
					<td>{{tableRow.discussUserName}}</td>
				</tr>
				<tr>
					<th>评论内容</th>
					<td>{{tableRow.content}}</td>
				</tr>
				<tr>
					<th>添加时间</th>
					<td>{{tableRow.addTime|datefmt2('YYYY-MM-DD HH:mm:ss')}}</td>
				</tr>
				<tr>
					<th>显示状态</th>
					<td>
						<span v-if="tableRow.showFlag==1">显示</span>
						<span v-if="tableRow.showFlag==0">不显示</span>
					</td>
				</tr>
			</table>
		</el-dialog>
	</div>
</template>

<script>
	import Pagination from '@/components/admin/pagination'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'CommentList',
		components: {
			Pagination
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				total: 0,
				dataList: [],
				showFlag: '', //1显示  0不显示
				title: '', //内容
				discussUserName: '', //评论人
				refId: '', //动态id
				feedDetailModel: {},
				visibleDialog: false,
				tableRow: {}
			}
		},
		created(){
			this.refId = this.$route.query.id||''
			this.getFeedList()
			this.getDataList()
		},
		methods: {
			//动态详情
			async getFeedList(){
				let param = {
					id: this.refId
				}
				ajaxParam(param)
				const res = await post('admin/feed/detail', qs.stringify(param))
				if (res.data.code == 200) {
					console.log(res.data)
					this.feedDetailModel = res.data.entity
				}
			},
			//获取评论列表
			async getDataList() {
				let param = {
					refId: this.refId,
					title: this.title,
					discussUserName: this.discussUserName,
					showFlag: this.showFlag,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/discussInfo/list', qs.stringify(param))
				if (res.data.code == 200) {
					let datalist = res.data.page.items
					this.dataList = datalist
					this.total = res.data.page.count
				}
			},
			//分页
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			},
			toSearch(){
				this.getDataList()
			},
			toReset(){
				this.showFlag = ''
				this.title = ''
				this.discussUserName = ''
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
			},
			setSelectedShow(e){
				this.showFlag = e
				this.pageNum = 1
				this.dataList = []
				this.getDataList()
			},
			toDetail(row){
				this.visibleDialog = true
				this.tableRow = {
					discussUserName: row.discussUserName,
					content: row.content,
					addTime: row.addTime,
					showFlag: row.showFlag
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import url("../../../table.less");
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}
	.feed-wrap{
		margin-bottom: 10px;
		.feed-top{
			display: flex;
			justify-content: space-between;
			width: 480px;
			padding: 10px 0;
			font-weight: bold;
		}
		img, video{
			width: 300px;
		}
	}
	.text-link{
		color: #EB6B1B; cursor: pointer;
	}
	/deep/ .activity-form-wrap .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px!important;
	}
	
	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}
	
	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 8px;
	}
	
	/deep/ .el-button {
		font-size: 12px !important;
	}
</style>